var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2c-.276.004-.504.224-.5.5v4c0 .822.678 1.5 1.5 1.5h4c.668.01.646-1 0-1h-4c-.286 0-.5-.214-.5-.5v-4c.004-.282-.218-.504-.5-.5zm-15-2C3.678 0 3 .678 3 1.5v27c0 .822.678 1.5 1.5 1.5h21c.822 0 1.5-.678 1.5-1.5v-21c0-.133-.053-.26-.146-.354l-7-7C19.76.053 19.634 0 19.5 0zm0 1h14.793L26 7.707V28.5c0 .286-.214.5-.5.5h-21c-.286 0-.5-.214-.5-.5v-27c0-.286.214-.5.5-.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFile);
export default __webpack_public_path__ + "static/media/new-file.63aa0f5a1fe5c5cf0f4935df43593231.svg";
export { ForwardRef as ReactComponent };